import { Tooltip, TooltipContent, TooltipTrigger, cn } from "@k3-tech/react-kit";
import { Barcode } from "lucide-react";

interface ProductCellProps {
  productCode?: string | null;
  productName?: string | null;
  barcode?: string | null;
  isConsignment?: boolean | null;
  className?: string;
}

export default function ProductCell({
  productCode,
  productName,
  barcode,
  isConsignment,
  className,
}: ProductCellProps) {
  return (
    <div
      className={cn(
        "flex w-0 min-w-full flex-col leading-tight",
        className,
      )}
    >
      {barcode &&
        (productCode ? (
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="flex w-fit max-w-full items-center gap-1.5 font-semibold text-[#1976F2]">
                <Barcode className="size-4 shrink-0" />
                <span className="truncate">{barcode}</span>
              </span>
            </TooltipTrigger>
            <TooltipContent>SKU: {productCode}</TooltipContent>
          </Tooltip>
        ) : (
          <span className="flex w-fit max-w-full items-center gap-1.5 font-semibold text-[#1976F2]">
            <Barcode className="size-4 shrink-0" />
            <span className="truncate">{barcode}</span>
          </span>
        ))}
      <div className="flex items-center gap-1.5 min-w-0">
        {productName && (
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="w-fit max-w-full truncate font-medium text-slate-900 dark:text-white">
                {productName}
              </span>
            </TooltipTrigger>
            <TooltipContent className="max-w-[320px]">
              {productName}
            </TooltipContent>
          </Tooltip>
        )}
        {isConsignment && (
          <span className="shrink-0 rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-semibold text-amber-800 dark:bg-amber-900/40 dark:text-amber-300">
            Consignment
          </span>
        )}
      </div>
    </div>
  );
}
